module.exports = __webpack_public_path__ + "img/header-weddingRingsCheap@2x.41daa5d.jpg";